import { batch, useDispatch, useSelector } from 'react-redux'
import { ConfirmModal } from 'components/dialog/ModalTemplate'
import { Modal } from 'components/dialog/Modals'
import {
  createTrackRight,
  resetCreateTrack,
  setName,
  showInstallTrackModal,
} from 'features/crux/tracker/modal/create/createTrackSlice'
import TextInput from 'components/form/TextInput'
import Button from 'components/form/Button'
import { fail } from 'features/toast/Toast'
import {
  fetchLinkedTracks,
  setTab,
} from 'features/crux/tracker/list/trackerListSlice'
import { showKakaoServices } from 'features/crux/tracker/modal/kakaoService/kakaoServiceTrackSlice'

const CreateTrack = () => {
  const dispatch = useDispatch()
  const {
    visibleCreate: visible,
    name,
    isLoading,
    trackId,
  } = useSelector(state => state.tracker.createTrack)
  const { id: adAccountId, name: adAccountName } = useSelector(
    state => state.account.current
  )
  const { tab } = useSelector(state => state.tracker.trackerList)
  return (
    <Modal className="pixelcreat_layer" on={visible}>
      <ConfirmModal
        title="픽셀 & SDK 만들기"
        handleClose={() => {
          batch(() => {
            dispatch(resetCreateTrack())
            if (tab !== 'linked') {
              setTab('linked')
            }
            dispatch(fetchLinkedTracks())
          })
        }}
        showCancelBtn={false}>
        <p className="desc_pixelcreat">
          픽셀 &amp; SDK는 광고주 웹사이트 또는 앱에 설치하여 효율적인 타게팅과
          광고 최적화를 위하여 사용하는 도구입니다. 아래에 이름을 입력 후 등록
          버튼을 클릭하면, 픽셀 &amp; SDK 만들기가 완료됩니다.
        </p>
        <div className="box_search2">
          <form
            autoComplete="off"
            onSubmit={async event => {
              event.preventDefault()
              if (name.trim().length === 0) {
                fail('픽셀&SDK 이름을 입력하세요.')
              } else {
                const { error, payload } = await dispatch(createTrackRight())
                if (error) {
                  fail(payload?.message || '알 수 없는 에러가 발생했습니다.')
                }
              }
            }}>
            <TextInput
              value={name}
              onValueChange={v => dispatch(setName(v))}
              maxLength={15}
              placeholder="픽셀 &amp; SDK 이름을 입력하세요."
              disabled={trackId !== null || isLoading}
            />
            <Button
              type="submit"
              disabled={
                trackId !== null || isLoading || name.trim().length === 0
              }>
              등록
            </Button>
          </form>
        </div>
        {trackId !== null && (
          <>
            <p className="desc_pixelcreat">
              픽셀 &amp; SDK 만들기가 완료되었습니다.
            </p>
            <div className="box_info">
              <p className="desc_info">이름: {name}</p>
              <p className="desc_info">ID: {trackId}</p>
              <p className="desc_info">
                연동된 광고계정: {adAccountName}({adAccountId})
              </p>
            </div>
            <p className="desc_pixelcreat">
              픽셀 &amp; SDK에 카카오톡 채널, 톡스토어, 선물하기, 웹사이트, 앱을
              연동하여, 각 서비스에서 발생하는 방문, 회원가입, 구매와 같은
              이벤트를 수집하세요. 이벤트를 수집하면 광고 성과를 높일 수
              있습니다.
            </p>
            <div className="box_pixelcreat">
              <ul className="list_g">
                <li>
                  <strong className="tit_g">
                    운영 중인 카카오 서비스에서 이벤트 수집하기
                  </strong>
                  <Button line onClick={() => dispatch(showKakaoServices())}>
                    카카오 서비스 연동하기
                  </Button>
                </li>
                <li>
                  <strong className="tit_g">
                    운영 중인 웹사이트나 앱에 픽셀 &amp; SDK 설치하여 이벤트
                    수집하기
                  </strong>
                  <Button
                    line
                    onClick={() => dispatch(showInstallTrackModal('web'))}>
                    웹 카카오픽셀 설치하기
                  </Button>
                  <Button
                    line
                    onClick={() => dispatch(showInstallTrackModal('app'))}>
                    앱 카카오SDK 설치하기
                  </Button>
                </li>
              </ul>
            </div>
          </>
        )}
      </ConfirmModal>
    </Modal>
  )
}
export default CreateTrack
